import { render, staticRenderFns } from "./UserRequests.vue?vue&type=template&id=7a159ac8&scoped=true&"
import script from "./UserRequests.vue?vue&type=script&lang=js&"
export * from "./UserRequests.vue?vue&type=script&lang=js&"
import style0 from "./UserRequests.vue?vue&type=style&index=0&id=7a159ac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a159ac8",
  null
  
)

export default component.exports